import React from "react";
import ArchivePageHeaderDescription from "archive/components/ArchivePageHeaderDescription";
import ArchiveConfigForm from "archive/components/ArchiveConfigForm";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { ARCHIVE_LICENSE_WARNING_TITLE, ARCHIVE_LICENSE_WARNING_TEXT } from "archive/constants";
import ArchivePageNavigation from "./components/ArchivePageNavigation";
const ArchiveConfigurationPage = () => /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Archives configuration" }, /* @__PURE__ */ React.createElement(ArchivePageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "Edit archives configuration" }, /* @__PURE__ */ React.createElement(ArchivePageHeaderDescription, null)), /* @__PURE__ */ React.createElement(
  LicenseCheck,
  {
    text: ARCHIVE_LICENSE_WARNING_TEXT,
    title: ARCHIVE_LICENSE_WARNING_TITLE,
    licenseSubject: LICENSE_SUBJECTS.archive,
    displayWarningContainer: true,
    bsStyle: "danger"
  }
), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { lg: 8 }, /* @__PURE__ */ React.createElement(ArchiveConfigForm, null))));
export default ArchiveConfigurationPage;
